module.exports = __webpack_public_path__ + "img/view_fill_form_icon.d1147a69.svg";